import React from 'react'
import { Box } from 'theme-ui'

export const HeaderLogo = () => (
  <Box as='h3' sx={{ m: 0, maxWidth: '24rem', fontSize: '1.125rem', lineHeight: 1.4 }}>
    Dipl.-Psych. Hild
    <Box as='small' sx={{ display: 'block', mt: 2, fontSize: '0.875rem', lineHeight: 1.5 }}>
      Psychologische Psychotherapie<br />
      Verhaltenstherapie
      <Box as='span' sx={{ display: 'block', mt: 2 }}>
        offene Haltung gegenüber<br />
        schulenübergreifenden Ansätzen
      </Box>
    </Box>
  </Box>
)
